import React, { useEffect, useState, useContext } from "react";

import { useNavigate } from "react-router-dom";

import TrialExpiredModal from "./TrialExpiredModal";

import { SchoolSignupContext } from "../context/SchoolSignupContext";

import {

  verifySchoolSubscriptionBlocked,

  getPaymentRedirectUrl,

  cancelTrialSubscription,

  completeSubscriptionCancellation,

} from "../utils/schoolSubscription";

import { toast } from "react-toastify";



const SubscriptionGate = ({ children }) => {

  const navigate = useNavigate();

  const { signupData } = useContext(SchoolSignupContext);

  const [showModal, setShowModal] = useState(false);

  const [checking, setChecking] = useState(true);

  const [cancelLoading, setCancelLoading] = useState(false);



  useEffect(() => {

    let cancelled = false;



    const verifyAccess = async () => {

      const baseURL = process.env.REACT_APP_BASE_URL;

      const blocked = await verifySchoolSubscriptionBlocked(baseURL, {

        ...signupData,

        schoolCode: signupData.schoolCode ?? signupData.verificationCode,

      });



      if (!cancelled) {

        if (blocked) {

          localStorage.removeItem("access_token");

          setShowModal(true);

        }

        setChecking(false);

      }

    };



    verifyAccess();



    return () => {

      cancelled = true;

    };

  }, [signupData]);



  const handleActivatePlan = () => {

    const paymentUrl = getPaymentRedirectUrl(signupData);

    if (!paymentUrl) {

      toast.error("Payment page URL is not configured. Please contact your administrator.");

      return;

    }

    window.location.href = paymentUrl;

  };



  const handleCancelSubscription = async () => {

    const baseURL = process.env.REACT_APP_BASE_URL;

    setCancelLoading(true);

    try {

      await cancelTrialSubscription(baseURL, signupData);

      completeSubscriptionCancellation(signupData);

      setShowModal(false);

      toast.success("Your subscription has been cancelled.");

      navigate("/landingpage", { replace: true });

    } catch (error) {

      toast.error(

        error.message || "Failed to cancel subscription. Please try again."

      );

    } finally {

      setCancelLoading(false);

    }

  };



  if (checking) {

    return null;

  }



  if (showModal) {

    return (

      <TrialExpiredModal

        open={showModal}

        onActivatePlan={handleActivatePlan}

        onCancelSubscription={handleCancelSubscription}

        cancelLoading={cancelLoading}

      />

    );

  }



  return children;

};



export default SubscriptionGate;


